/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-undef */
import React from "react";
import FunctionalityButton from "./FunctionalityButton";
import axios from "axios";
import { getToken } from "@/helpers/accessTokenHelper";
import { getSiteIdentifier } from "@/helpers/siteIdentifierHelper";
import { getDriveItemId } from "@/helpers/fallback-response-helper";
import { ensureDocumentSaved } from "@/taskpane/utility/ensureDocumentSaved";

export default function AcceptAllChanges({ setStatus, loading, setHovered }) {
  const reviseDocument = async (revise, driveItemId, comments) => {
    return await axios.patch(
      `https://addins.api.dexterity.legal/gateway/api/v1/documents/revise?driveItemId=${driveItemId}`,

      {
        acceptRevision: revise,
        removeComments: comments,
      },
      {
        headers: {
          Authorization: "Bearer " + (await getToken()),
          "Site-Identifier": getSiteIdentifier(),
          "Ocp-Apim-Subscription-Key": "6a6c8e6075cc4402a6839fa2ecc950f1",
        },
      }
    );
  };

  async function acceptAllRevisions(revision) {
    loading(true);
    Office.context.document.getFilePropertiesAsync(async (context) => {
      const driveItemId = getDriveItemId(JSON.parse(sessionStorage.getItem("document")));
      // The server revises the SharePoint copy, so Word's latest edits must be uploaded first.
      // If the save did not confirm, stop: replacing the body with a revision of the stale copy would drop edits.
      if (JSON.parse(sessionStorage.getItem("document")).fileType !== "sent" && !(await ensureDocumentSaved())) {
        loading(false);
        return;
      }
      await Word.run(async (context) => {
        reviseDocument(revision, driveItemId, false)
          .then(async (response) => {
            const currentDocBody = context.document.body;
            currentDocBody.insertFileFromBase64(response.data.data, Word.InsertLocation.replace);
            await context.sync();
            context.document.save();
            await context.sync();
          })
          .then(() => {
            setStatus(true);
            loading(false);
          });
      }).catch(function (error) {
        console.log("error:", error);
      });
    });
  }
  return (
    <div>
      <FunctionalityButton
        buttonText="Accept All Changes"
        color="#2b579a"
        bgColor="#A82C0C"
        onClickFunction={() => acceptAllRevisions(true)}
        setHovered={setHovered}
      />
    </div>
  );
}
